export const rootId = 0;
export const defaultCronSchedule = "0 0 * * * ? *";
